import { apiClient, API_BASE_URL } from '@/lib/api/client'

export async function uploadImage(file: File): Promise<string> {
  const formData = new FormData()
  formData.append('file', file)
  const res = await apiClient.post<{ success: boolean; data: { url: string } }>(
    '/admin/upload/image',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 60000 },
  )
  const url = res.data.data?.url
  if (!url) throw new Error('Upload thất bại')
  // trả URL tuyệt đối (frontend gắn API host vì backend serve static)
  const origin = new URL(API_BASE_URL).origin
  return url.startsWith('http') ? url : `${origin}${url}`
}
